import { webProductsApiAxiosInstance } from '@/helpers/request'
import products from '@/data/products/index'
import upsellProducts from '@/data/products/upsell/index'
import Sentry from '@/modules/Sentry'

export default {
	namespaced: true,

	state: {
		products: [],
		loading: false,
	},

	mutations: {
		setProducts(state, products) {
			state.products = products.map((product) => {
				const phases = product.phases.reduce((acc, phase) => {
					acc[phase.type] = phase
					return acc
				}, {})

				return {
					...product,
					...phases,
				}
			})
		},

		setLoading(state, loading) {
			state.loading = loading
		},
	},

	getters: {
		getProductById: (state) => (id) => {
			const product = state.products.find((product) => product.ident === id)

			if (!product) {
				Sentry.withScope((scope) => {
					scope.setExtras({ productId: id })
					scope.setTags({ productsError: true })
					scope.captureMessage(`Product with id ${id} not found`)
				})
				return {}
			}

			return product
		},

		getProductsByIds: (state, getters) => (ids) => {
			return ids.map((id) => getters.getProductById(id))
		},

		getLoading: (state) => state.loading,
	},

	actions: {
		async fetchProducts({ commit, rootGetters }, { ids, promocode, primerIds }) {
			const productIds = Array.isArray(ids) ? ids : [ids]
			const hasPrimerIds = Array.isArray(primerIds) && primerIds.length > 0

			const primerProductIds = hasPrimerIds
				? primerIds
				: [
						...new Set(
							productIds.map((id) => {
								const product = products[id] || upsellProducts[id]

								return product.providers.primer
							}),
						),
				  ]

			try {
				commit('setLoading', true)

				const response = await webProductsApiAxiosInstance.get('/billing-api/v1/products', {
					params: {
						'idents[]': primerProductIds,
						currency: rootGetters.getCurrencyUppercase,
						country_code: rootGetters.getCountryCodeUppercase,
						promocode,
					},
				})

				const missingProducts = primerProductIds.filter((id) => {
					return !response.data.find((product) => product.ident === id)
				})

				const responseHasEveryProduct = missingProducts.length === 0

				commit('setProducts', response.data)

				if (!responseHasEveryProduct) {
					throw new Error(`Some products are not found: ${missingProducts.join(', ')}`)
				}
			} catch (error) {
				Sentry.withScope((scope) => {
					scope.setExtras({ products: productIds })
					scope.setTags({ productsError: true })
					scope.captureException(error)
				})
			} finally {
				commit('setLoading', false)
			}
		},
	},
}
